// 集中管理Element Plus图标
// 仅导入常用图标，减少初始加载体积

// 基础图标（始终加载）
import {
  Edit, Delete, Plus, Search, View, Share,
  ArrowLeft, ArrowRight, Refresh, User,
  Message, TrendCharts, HomeFilled, Setting, ChatDotRound,
  ArrowUp, ArrowDown, Download, Trophy, Star,
  Collection, StarFilled, Service, Phone, Box,
  MoreFilled, Picture, VideoCamera, Document, Smile
} from '@element-plus/icons-vue'

// 按需加载的图标映射
const iconMap = {
  Edit,
  Delete,
  Plus,
  Search,
  View,
  Share,
  ArrowLeft,
  ArrowRight,
  Refresh,
  User,
  Message,
  Stats: TrendCharts, // 别名以保持原有使用方式
  Home: HomeFilled, // 别名以保持原有使用方式
  Setting,
  ChatDotRound,
  ArrowUp,
  ArrowDown,
  Download,
  Trophy,
  Star,
  Robot: Service, // 替代方案：使用Service代替不存在的Robot图标
  Collection,
  StarFilled,
  Like: StarFilled, // 替代方案：使用StarFilled代替不存在的Like图标
  UserDelete: Delete, // 替代方案：使用Delete代替不存在的UserDelete图标
  Phone,
  Box,
  MoreFilled,
  Picture,
  VideoCamera,
  Document,
  Smile
}

// 图标注册函数
export function registerIcons (app) {
  // 注册基础图标
  Object.entries(iconMap).forEach(([key, component]) => {
    app.component(key, component)
  })
}

// 动态导入图标（按需加载）
export async function loadIcon (iconName) {
  // 如果图标已在基础图标中，直接返回
  if (iconMap[iconName]) {
    return iconMap[iconName]
  }

  // 动态导入其他图标
  try {
    const { [iconName]: IconComponent } = await import('@element-plus/icons-vue')
    return IconComponent
  } catch (error) {
    console.error(`Failed to load icon ${iconName}:`, error)
    return null
  }
}

// 获取已注册的图标列表
export function getRegisteredIcons () {
  return Object.keys(iconMap)
}

// 检查图标是否已注册
export function hasIcon (iconName) {
  return iconName in iconMap
}
